import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class FinalPackageService {

  constants: Constants = new Constants();

  constructor(private readonly http: HttpClient) { }

  HTTP_CONSTANT_OPTIONS_GET = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
      'Accept': 'application/json',
    })
  };

  getDomicilesData(): Observable<any> {
    console.info("Entered Domiciles Logic");

    return this.http
      .get(this.constants.getApiBasePath() + `/maxloadData/getdomiciles/`, this.HTTP_CONSTANT_OPTIONS_GET)
      .pipe(
        tap(_ => this.log('Domiciles Data Retrived Successful')),
        catchError(this.handleError<any>('Domiciles Data Retrival Generated Error'))
      );
  };

  getPeriodsData(): Observable<any> {
    console.info("Entered Period Logic");

    return this.http
      .get(this.constants.getApiBasePath() + `/maxloadData/getperiods/`, this.HTTP_CONSTANT_OPTIONS_GET)
      .pipe(
        tap(_ => this.log('Period Data Retrived Successful')),
        catchError(this.handleError<any>('Period Data Retrival Generated Error'))
      );
  }


  private handleError<T>(_operation: string, result?: T) {
    return (error: any): Observable<T> => {
      console.info(error); // log to console instead
      return of(result as T);
    };
  }

  /** Log a message */
  private log(message: string) {
    console.info('Message: ' + message);
  }

}
